import { createSlice } from "@reduxjs/toolkit";
import { updateAiCampaignStatusAPI } from "../../services/updateAiCampaignStatus";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const updateAiCampaignStatusSlice = createSlice({
  name: "updateAiCampaignStatus",
  initialState: data,
  reducers: {
    updateAiCampaignStatusInfo(state) {
      state.isLoading = true;
      state.error = "";
      state.message = "";
    },
    updateAiCampaignStatusInfoSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "Campaign status updated successfully";
      state.error = "";
    },
    updateAiCampaignStatusInfoFailure(state, action) {
      state.isLoading = false;
      state.message = "";
      state.error = action.payload;
      state.data = null;
    },
    updateAiCampaignStatusInfoReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const updateAiCampaignStatusHandler = (payload) => async (dispatch) => {
  try {
    dispatch(updateAiCampaignStatusAction.updateAiCampaignStatusInfo());
    const response = await updateAiCampaignStatusAPI(payload);
    dispatch(updateAiCampaignStatusAction.updateAiCampaignStatusInfoSuccess(response));
  } catch (e) {
	  console.log(e,"essssssss");
    dispatch(
      updateAiCampaignStatusAction.updateAiCampaignStatusInfoFailure(
        e
      )
    );
  }
};

export default updateAiCampaignStatusSlice.reducer;
export const updateAiCampaignStatusAction = updateAiCampaignStatusSlice.actions;
